// extracted by mini-css-extract-plugin
export default {"root":"ResourceEmpty_root__Xz0mY","btn":"ResourceEmpty_btn__Q1GR8"};